import React from 'react';
import { Typography } from '@/ui-kit';
import styles from './progress-redesigned.module.scss';

interface Props {
    progress: number;
    size?: number;
    color?: string;
    withText?: boolean;
}

export const ProgressRedesigned: React.FC<Props> = ({ progress, size = 56, color = '#fff', withText = false }) => {
    const radius = size / 2; // Радиус круга
    const strokeWidth = 3; // Толщина линии
    const normalizedRadius = radius - strokeWidth / 2;
    const circumference = 2 * Math.PI * normalizedRadius;
    const strokeDashoffset = (circumference - (progress / 100) * circumference);

    return (
        <div className={styles.progress}>
            <svg
                height={radius * 2}
                width={radius * 2}
                className={styles.progressSvg}>
                <circle
                    className={styles.progressCircle}
                    stroke={'#a6a6a8'}
                    fill="transparent"
                    strokeWidth={strokeWidth}
                    r={normalizedRadius}
                    cx={radius}
                    cy={radius} />
                <circle
                    className={styles.progressCircle}
                    stroke={color}
                    fill="transparent"
                    strokeWidth={strokeWidth}
                    strokeDasharray={circumference}
                    strokeDashoffset={strokeDashoffset}
                    strokeLinecap="round"
                    r={normalizedRadius}
                    cx={radius}
                    cy={radius} />
            </svg>
            {withText && (
                <Typography
                    className={styles.progressText}
                    typeColor="white"
                    fontWeight="medium"
                    center>
                    {progress}%
                </Typography>
            )}
        </div>
    );
};
